// The dashboard's checkbox: a small rounded box, green when checked (green
// being the accent), with its label beside it. The native input stays inside,
// visually hidden, so forms, tests and data-* attributes on it keep working.
// `onChange(checked, event)`.
import { CheckIcon } from "@heroicons/react/24/outline";

export default function Checkbox({ checked, onChange, label = null, disabled = false, className = "", ...inputProps }) {
    return (
        <label className={`inline-flex select-none items-center gap-[8px] text-[13px] leading-[1.3] ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"} ${checked ? "text-[color:var(--ink)]" : "text-[color:var(--muted)] hover:text-[color:var(--ink)]"} ${className}`}>
            <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={(event) => onChange?.(event.target.checked, event)}
                className="peer sr-only"
                {...inputProps}
            />
            <span
                aria-hidden="true"
                className={`grid h-[16px] w-[16px] shrink-0 place-items-center rounded-[4px] border transition-colors duration-150 peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-1 peer-focus-visible:outline-[color:var(--green)] ${checked
                    ? "border-[color:var(--green)] bg-[color:var(--green)]"
                    : "border-[color:var(--line-strong)] bg-transparent"}`}
            >
                <CheckIcon strokeWidth={3} className={`h-[11px] w-[11px] text-[color:var(--bg)] ${checked ? "" : "invisible"}`} />
            </span>
            {label}
        </label>
    );
}
